module.exports = __webpack_public_path__ + "img/restaurant-3.0fe61311.jpg";